



































































































































































import { Component, Vue } from "vue-property-decorator";
import TextItem from "@/components/TextItem.vue";
import CheckBoxItem from "@/components/CheckBoxItem.vue";
import RadioItem from "@/components/RadioItem.vue";
import EmailItem from "@/components/EmailItem.vue";
import DateItem from "@/components/DateItem.vue";
import SelectItem from "@/components/SelectItem.vue";
import TextAreaItem from "@/components/TextAreaItem.vue";
import CountrySelectItem from "@/components/CountrySelectItem.vue";
import NumberItem from "@/components/NumberItem.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Route } from "vue-router";
import { SurveyForm } from "@/models/SurveyForm";
import { SurveyItem } from "@/models/SurveyItem";
import { SurveyText } from "@/models/SurveyText";
import { create, QRCodeErrorCorrectionLevel } from "qrcode";
import { serializeSurveyForm } from "@/serialization/serialization";
import zlib from "zlib";
import NodeRSA from "node-rsa";
import crypto from "crypto";

export enum FontSize {
  small,
  medium,
  large
}

interface VSelectLanguageInterface {
  text: string;
  value: number;
}

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  components: {
    CountrySelectItem,
    TextAreaItem,
    SelectItem,
    TextItem,
    RadioItem,
    CheckBoxItem,
    EmailItem,
    DateItem,
    ValidationProvider,
    ValidationObserver,
    NumberItem
  }
})
export default class Survey extends Vue {
  surveyForm: SurveyForm = new SurveyForm(
    "",
    "",
    "",
    "",
    [],
    [],
    [],
    "",
    false,
    []
  );

  languageItems: VSelectLanguageInterface[] = [];
  selectedLanguageValue = 0;
  qrValidationErrorMsg = "";
  qrpublickeyErrorMsg = "";
  showQuestionnaire = true;

  isSmallActive = false;
  isMediumActive = false;
  isLargeActive = true;

  fontSizeItems: { text: string; value: FontSize }[] = [];
  selectedFontSize = FontSize.large;

  async created() {
    const json = this.$route.query.json;
    if (typeof json === "string") {
      this.surveyForm = await SurveyForm.getInstanceForJsonUrl(json);
      this.surveyForm.surveyItems = SurveyItem.initSurveyItemsValue(
        this.surveyForm.surveyItems
      );
      this.showQuestionnaire = this.validateFilename(
        json.replace(".json", ""),
        this.surveyForm
      );
    } else {
      this.surveyForm = SurveyForm.getInstance(this.$route.query);
    }
    //クエリからdefault_answes取得
    const defaultanswers = this.$route.query.default_answers;
    if (defaultanswers !== undefined) {
      const defaultanswersString = defaultanswers.toString();
      //文字列から配列に変換
      const defaultarray = JSON.parse(defaultanswersString);

      for (let i = 0; i < defaultarray.length; i++) {
        if (
          this.surveyForm.surveyItems[i].type == "st" ||
          this.surveyForm.surveyItems[i].type == "em" ||
          this.surveyForm.surveyItems[i].type == "ta" ||
          this.surveyForm.surveyItems[i].type == "dt"
        ) {
          this.surveyForm.surveyItems[i].value = defaultarray[i][1];
        }
      }
    }

    // 言語選択のドロップダウンリストを設定
    this.languageItems = this.surveyForm.langs.map((v, i) => {
      return { text: v.text, value: i };
    });
    this.selectedLanguageValue = this.loadLocalNumber("__SelectedLangValue__");
    document.title = this.surveyForm.title[this.selectedLanguageValue].text;
    this.$i18n.locale =
      this.surveyForm.langs[this.selectedLanguageValue].lang === "ja"
        ? "ja"
        : "en";
    this.setupFontSizeItems();
    /** 編集の戻るボタン抑制(ただし、ブラウザの不正対策により発動しない事あり) */
    window.addEventListener("beforeunload", this.confirmSave);
  }

  destroyed() {
    window.removeEventListener("beforeunload", this.confirmSave);
  }

  setupFontSizeItems() {
    this.fontSizeItems = [];
    this.fontSizeItems = [
      {
        text: this.$t("fontSizes.small").toString(),
        value: FontSize.small
      },
      {
        text: this.$t("fontSizes.medium").toString(),
        value: FontSize.medium
      },
      {
        text: this.$t("fontSizes.large").toString(),
        value: FontSize.large
      }
    ];
  }

  /**
   * EditorのJSONダウンロード機能によるファイル名が使用されているかを確認
   * @return バリデーション結果を返す
   * @private
   */
  validateFilename(filename: string, survey: SurveyForm) {
    return filename === survey.surveyId + "_" + survey.hashCode;
  }

  displayText(surveyTexts: SurveyText[]) {
    if (surveyTexts.length === 0) {
      return "";
    }
    return surveyTexts[this.selectedLanguageValue].text;
  }

  loadLocalNumber(id: string) {
    let value: number;
    try {
      value = JSON.parse(localStorage.getItem(id) ?? "") as number;
    } catch (e) {
      value = 0;
    }
    return value;
  }

  saveLocalNumber(id: string, value: number) {
    localStorage.setItem(id, JSON.stringify(value));
  }

  changeFontSize(value: FontSize) {
    this.isSmallActive = false;
    this.isMediumActive = false;
    this.isLargeActive = false;
    switch (value) {
      case FontSize.small:
        this.isSmallActive = true;
        break;
      case FontSize.medium:
        this.isMediumActive = true;
        break;
      case FontSize.large:
        this.isLargeActive = true;
        break;
    }
  }

  changeLanguage(value: number) {
    this.$i18n.locale =
      this.surveyForm.langs[this.selectedLanguageValue].lang === "ja"
        ? "ja"
        : "en";
    document.title = this.surveyForm.title[this.selectedLanguageValue].text;
    this.setupFontSizeItems();
    this.saveLocalNumber("__SelectedLangValue__", value);
  }

  /** 編集の戻るボタン抑制(ただし、ブラウザの不正対策により発動しない事あり) */
  confirmSave(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = "";
  }

  /**
   * 戻るボタン押下時にデータ削除URLに戻るのを阻止
   * @param to
   * @param from
   * @param next
   * @private
   */
  beforeRouteLeave(to: Route, from: Route, next: Function) {
    if (to.name == "Delete") {
      const json = this.$route.query.json;
      if (typeof json === "string") {
        next("/?json=" + this.$route.query.json);
      } else {
        next("/?cols=" + this.$route.query.cols);
      }
    } else {
      next();
    }
  }

  validateQRCharacterNumberString(
    qrText: string,
    errorCorrectionLevel: QRCodeErrorCorrectionLevel = "L"
  ) {
    let success = true;
    try {
      create(qrText, {
        errorCorrectionLevel: errorCorrectionLevel
      });
    } catch (e) {
      success = false;
      console.error(e);
    }
    return success;
  }

  validateQRCharacterNumberBuffer(
    qrText: Buffer,
    errorCorrectionLevel: QRCodeErrorCorrectionLevel = "L"
  ) {
    let success = true;
    try {
      create([{ data: qrText, mode: "byte" }], {
        errorCorrectionLevel: errorCorrectionLevel
      });
    } catch (e) {
      success = false;
      console.error(e);
    }
    return success;
  }

  async createQR() {
    /**
     * 圧縮
     */
    function deflate(val: string) {
      const buf = Buffer.from(val, "utf8");
      const deflated = zlib.deflateRawSync(buf);
      return deflated;
    }

    type ValidationObserverRef = InstanceType<typeof ValidationObserver>;
    const observer = this.$refs.validationObserver as ValidationObserverRef;
    const success = await observer.validate();
    if (success) {
      const passportid = this.$route.query.passport;
      const qrData = serializeSurveyForm(this.surveyForm, passportid);

      //公開鍵をクエリから取得
      const publickeyData = this.$route.query.public_key;
      //公開鍵がない時、平文をQR化
      if (publickeyData == undefined) {
        if (this.validateQRCharacterNumberString(qrData)) {
          // QRの文字数上限問題なし
          this.$store.setSurveyForm(this.surveyForm);
          await this.$router.push({
            name: "SurveyQRView",
            query: this.$route.query
          });
        } else {
          // QRの文字数上限エラー
          this.qrValidationErrorMsg = this.$t(
            "validations.qrCharacterNumber"
          ).toString();
        }
      }
      //公開鍵がある時、暗号文をQR化
      else {
        /**
         * AES暗号化
         */
        const AESencrypt = (
          data: Buffer,
          algoritm: string,
          key: Buffer,
          iv: Buffer
        ) => {
          const cipher = crypto.createCipheriv(algoritm, key, iv);
          let encrypted = cipher.update(data);
          encrypted = Buffer.concat([encrypted, cipher.final()]);
          return encrypted;
        };
        /**
         * RSA暗号化
         */
        //AESkeyとAESvectorをRSA公開鍵で暗号化
        const RSAencrypt = (AESkey: Buffer, AESiv: Buffer) => {
          //クエリから取得した公開鍵をstring化
          const RSApublickeyString = publickeyData.toString();
          //keyとvectorを合わせる
          const AESkeyiv = Buffer.concat([AESkey, AESiv]);
          //RSA暗号化
          const RSAkey = new NodeRSA();
          RSAkey.importKey(RSApublickeyString, "pkcs1-public-pem");
          const AESkeyEncrypted = RSAkey.encrypt(AESkeyiv);
          return AESkeyEncrypted;
        };

        //圧縮化
        const qrdatazip = deflate(qrData);
        // 暗号化
        const AESalgoritm = "aes-128-cbc";
        const AESkey = crypto.randomBytes(16);
        const AESiv = crypto.randomBytes(16);

        const ResultencryptAES = AESencrypt(
          qrdatazip,
          AESalgoritm,
          AESkey,
          AESiv
        );

        const AESkeyivencryptRSA = RSAencrypt(AESkey, AESiv);

        //RSA暗号化文のデータ長を取得
        const RSAlength = Buffer.from(AESkeyivencryptRSA).byteLength;
        //データ長を４桁にする
        const RSAlengthPadding = ("0000" + RSAlength).slice(-4);

        //平文(3バイト)(RSA暗号化部分のデータ長)＋	RSA暗号部分(AES暗号鍵、初期化ベクトル)＋AES暗号部分(QR結果データ)
        const QRbuffer = Buffer.concat([
          Buffer.from(RSAlengthPadding, "utf8"),
          AESkeyivencryptRSA,
          ResultencryptAES
        ]);
        localStorage.setItem("localQRstring", QRbuffer.toString("base64"));

        if (this.validateQRCharacterNumberBuffer(QRbuffer)) {
          // QRの文字数上限問題なし
          this.$store.setSurveyForm(this.surveyForm);
          await this.$router.push({
            name: "SurveyQRView",
            query: this.$route.query
          });
        } else {
          // QRの文字数上限エラー
          this.qrValidationErrorMsg = this.$t(
            "validations.qrCharacterNumber"
          ).toString();
        }
      }
    } else {
      // 最上部にある入力不備のアンケート項目位置までスクロール
      const firstErrorTop = Object.keys(observer.fields)
        .filter(key => observer.fields[key].invalid === true)
        .map(key => observer.refs[key].$el.getBoundingClientRect().top)
        .reduce((num1: number, num2: number) => Math.min(num1, num2));
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const offset = document.getElementById("app-bar")!.clientHeight * 2;
      window.scrollBy({ top: firstErrorTop - offset });
    }
  }
}
